const MIME_TYPE_TRANSFORMATIONS: Record<string, string> = {
  'application/vnd.ms-excel': 'text/csv', // @see moz bug https://bugzilla.mozilla.org/show_bug.cgi?id=1934918
};

export function isAccepted(file: File, accept: string[]) {
  if (accept.length === 0) return true;

  const name = file.name.toLowerCase();
  const type = normalizeFileType(file);

  return accept.some((rule) => {
    const lowerRule = rule.toLowerCase().trim();

    // Extension e.g. `.png`
    if (lowerRule.startsWith('.')) return name.endsWith(lowerRule);

    // Wildcard mime type e.g. `image/*`
    if (lowerRule.endsWith('/*')) return type.startsWith(lowerRule.slice(0, -1));

    // Treat anything else as exact mime type
    return type === lowerRule;
  });
}

function normalizeFileType(file: File): string {
  const type = file.type.toLowerCase();

  return MIME_TYPE_TRANSFORMATIONS[type] ?? type;
}
